// Frontend\src\component\demodashboard\flowdesigners\useEmailFlowLogic.js
import { useState } from "react";
import axios from "axios";
import emailjs from "@emailjs/browser";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const useEmailFlowLogic = () => {
  const [toEmail, setToEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleGenerate = async () => {
    if (!API_BASE) {
      console.error("API_BASE not defined");
      return;
    }
    if (!subject) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/email/generate-email-body`, { subject, tone: "professional" });
      setEmailBody(res.data.emailBody || "");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRefine = async (instruction) => {
    if (!API_BASE) {
      console.error("API_BASE not defined");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE}/api/email/refine-email-body`,
        { emailBody, instruction }
      );
      setEmailBody(res.data.emailBody || "");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSendEmail = async () => {
    if (!toEmail || !subject) {
      console.error("Missing recipient or subject");
      return;
    }
    setLoading(true);
    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID_FD,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_FD,
        {
          email: toEmail,
          subject,
          message: emailBody,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY_FD
      );
      setIsSent(true);
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    toEmail, setToEmail,
    subject, setSubject,
    emailBody, setEmailBody,
    handleGenerate,
    handleRefine,
    handleSendEmail,
    isConfirmed, setIsConfirmed,
    isSent,
    loading
  };
};
